import $ from 'jquery';

const htmlLinksSelector =
  '.btn, .btn--outline, .btn--reverse, .wp-block-button:not(.is-style-btn-icon-pdf):not(.is-style-btn-icon-external) .wp-block-button__link';

const addIconsInButton = (element) => {
  if (element.classList.contains('iconized')) {
    // BAIL. Already had icons added.
    return;
  }

  const linkHtml = element.innerHTML;
  const linkSpan =
    "<span class='btn-icon btn-icon--first icon-ArrowLeft'></span>" +
    linkHtml +
    "<span class='btn-icon btn-icon--last icon-ArrowLeft'></span>";
  element.innerHTML = linkSpan;
};

document.addEventListener('DOMContentLoaded', function () {
  //////////////////// ADD ARROW BUTTON AT LOAD ////////////////////
  document.querySelectorAll(htmlLinksSelector).forEach(function (element) {
    addIconsInButton(element);
  });
});

$(document).on('gform_post_render', function () {
  //////////////////// ADD ARROW BUTTON AFTER GFORM LOADED ////////////////////
  document.querySelectorAll(htmlLinksSelector).forEach(function (element) {
    addIconsInButton(element);
  });
});
